import axios from "axios";

// 语言开关的可选项由服务端统一配置，避免前端维护会变动的语言列表。
export const getLanguageList = () => {
  return axios.request({
    url: "/api/i18n/language/list",
    method: "post"
  });
};